import DEV_CONFIG from './config/development.json';
import PROD_CONFIG from './config/production.json';


const ENV_PRODUCTION = process.env.NODE_ENV == 'production';
export const config = {
    ...((ENV_PRODUCTION) ? PROD_CONFIG : DEV_CONFIG),
    DEBUG: !ENV_PRODUCTION
}

export const getEnvironment = (v) => (
    v ? config[v] : config
)

export const ASSET_URL = config.ASSET_URL
export const BASE_URL = config.BASE_URL
export const CREDENTIALS = config.CREDENTIALS
export const OAUTH2_CLIENT = config.ADMIN_OAUTH2_CLIENT
export const OAUTH2_REDIRECT_URI = config.ADMIN_OAUTH2_REDIRECT_URI
export const LOGIN_URL = config.LOGIN_URL
export const CREDENTIALS_URL = config.CREDENTIALS_URL
export const DEBUG = !ENV_PRODUCTION


export {Http} from './utils/Http.jsx';
export {Locale, i18n} from './utils/Locale.jsx';
export {PHONE_REGEXP, EMAIL_REGEXP, Credential} from './utils/Credential.jsx';
export {range, merge, arrayToObject, Collection} from './utils/Sequence.jsx';
export {parseRedirectQuery, tryRedirectToAffiliate} from './utils/Redirect.jsx';
export {exportToFile} from './utils/Export.jsx'

export const VARIABLE_REGEXP = /^([a-z0-9]*)(-[a-z0-9]+)*$/;
export const SCOPE_REGEXP = /^[a-zA-Z$][a-zA-Z\._$0-9]*$/;

export function capitalizeFirst(string) {
  if (string == null || string === '')
    return string;

  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const unwrapDynamic = (f, v) =>
  (typeof f === 'function') ? f(v) : f
